import { render, staticRenderFns } from "./FormulaSetting.vue?vue&type=template&id=736d736e&scoped=true&"
import script from "./FormulaSetting.vue?vue&type=script&lang=js&"
export * from "./FormulaSetting.vue?vue&type=script&lang=js&"
import style0 from "./FormulaSetting.vue?vue&type=style&index=0&id=736d736e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d736e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736d736e')) {
      api.createRecord('736d736e', component.options)
    } else {
      api.reload('736d736e', component.options)
    }
    module.hot.accept("./FormulaSetting.vue?vue&type=template&id=736d736e&scoped=true&", function () {
      api.rerender('736d736e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Settings/FormulaSetting.vue"
export default component.exports